import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';

class MasterStringsListItem extends Component {
  state = {
    context: this.props.string.props.context ? this.props.string.props.context : '',
    description: this.props.string.props.description ? this.props.string.props.description : '',
    isDirty: false
  }

  constructor (props) {
    super(props);
  }

	onTextUpdate = (param, useEventValue) => (e, string) => {
    if (useEventValue) {
      string = e.target.value;
    }
    this.updateParameter(param, string);
	}

  componentWillReceiveProps(newProps) {
    if (
      (newProps.originals.context !== this.props.originals.context && this.state.isDirty) ||
      (newProps.originals.description !== this.props.originals.description && this.state.isDirty)
    ) {
      this.setState({ isDirty: false });
    }
  }

  onAutocompleteSelect = (param) => (string) => {
    this.updateParameter(param, string);
  }

  willItemBeDirty (pendingState) {
    if (this.props.originals.context == pendingState.context && this.props.originals.description == pendingState.description) {
      return false;
    } else {
      return true;
    }
  }

  updateParameter (param, value) {
    let futureState = this.state;
    futureState[param] = value;

    this.props.string.props[param] = value;
    this.props.string.props.isDirty = this.willItemBeDirty(futureState);

    this.setState({
      [param]: value,
      isDirty: this.props.string.props.isDirty
    });

    this.props.changesBeacon();
  }

  getStringStatus () {
    if (this.state.isDirty) {
      return {
        text: 'edited',
        class: 'is-dirty'
      };
    }

    if (!this.state.context) {
      return {
        text: 'needs context',
        class: 'needs-filling'
      };
    }

    if (this.props.isSaving) {
      return {
        class: 'is-loading'
      };
    }

    return {
      class: null,
      text: null,
      color: null
    };
  }

  render () {
    const that = this;
    let status = this.getStringStatus();

    return (
      <tr className={status.class}>
        <td style={{verticalAlign: 'middle'}} title={this.props.string.props.key}>{this.props.string.props.key}</td>
        <td className="master" title={this.props.string.props.value}>{this.props.string.props.value}</td>
        <td style={{verticalAlign: 'middle', fontSize: '21px', overflow: 'visible'}}>
          <Autocomplete 
            value={this.state.context} 
            items={this.props.availableContexts}
            wrapperStyle={{ position: 'relative', display: 'inline-block' }}
            shouldItemRender={(item, value) => (!value) ? true : item.toLowerCase().indexOf(value.toLowerCase()) > -1}
            getItemValue={(item) => item}
            renderMenu={
              (items, value, style) => 
                <div className="autocomplete-suggestion-menu" style={{ minWidth: style.minWidth, ...this.menuStyle }} children={items}/>
            }
            renderItem={
              (item, isHighlighted) => 
                <div key={item} className={isHighlighted ? 'autocomplete-suggestion-item is-selected' : 'autocomplete-suggestion-item'}>
                  {item}
                </div>
            }
            renderInput={(props) => <input className="input" {...props} />}
            onChange={this.onTextUpdate('context')}
            onSelect={this.onAutocompleteSelect('context')}
            selectOnTab={true}
          />
        </td>
        <td>
          <input 
            onKeyUp={this.onTextUpdate('description', true)} 
            className="master.strings.item input" 
            defaultValue={this.state.description}
          />
        </td>
        <td className="help-message" title={status.text}>
          {status.text}
        </td>
      </tr>
    );
  }
}

export default MasterStringsListItem;


// WEBPACK FOOTER //
// ./src/Components/MasterStringsListItem.js